import _defineProperty from "/builds/telavita-core/frontend/core-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import React from 'react';
import PropTypes from 'prop-types';
import useStyles from './styles';
import { useDimensions } from '../../hooks';
import { Overlay } from '../Overlay';
import { Icon } from '../Icon';
import clsx from 'clsx';
import { Icons } from '../../types/icons';

var Drawer = function Drawer(_ref) {
  var _clsx;

  var children = _ref.children,
      open = _ref.open,
      setOpen = _ref.setOpen,
      _ref$anchor = _ref.anchor,
      anchor = _ref$anchor === void 0 ? 'left' : _ref$anchor,
      _ref$customClassName = _ref.customClassName,
      customClassName = _ref$customClassName === void 0 ? '' : _ref$customClassName,
      _ref$inlineStyles = _ref.inlineStyles,
      inlineStyles = _ref$inlineStyles === void 0 ? {} : _ref$inlineStyles;
  var classes = useStyles();

  var _useDimensions = useDimensions(),
      isMobile = _useDimensions.isMobile;

  var containerStyle = clsx((_clsx = {}, _defineProperty(_clsx, classes.container, true), _defineProperty(_clsx, classes[anchor], true), _defineProperty(_clsx, classes.mobile, isMobile), _defineProperty(_clsx, customClassName, Boolean(customClassName)), _clsx));
  if (!open) return null;
  return React.createElement(Overlay, null, React.createElement("div", {
    className: containerStyle,
    style: Object.assign({}, inlineStyles)
  }, React.createElement("div", {
    className: classes.content
  }, React.createElement(Icon, {
    onClick: function onClick() {
      return setOpen(false);
    },
    name: Icons.Close
  }), children)));
};

Drawer.propTypes = {
  children: PropTypes.node,
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired,
  anchor: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  customClassName: PropTypes.string,
  inlineStyles: PropTypes.object,
  animationConfig: PropTypes.shape({
    from: PropTypes.object,
    enter: PropTypes.object.isRequired,
    leave: PropTypes.object,
    config: PropTypes.object
  }),
  onClickOverlay: PropTypes.func,
  closeOnOverlayClick: PropTypes.bool
};
export { Drawer };